// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutosizeController from "./autosize_controller"
application.register("autosize", AutosizeController)

import AutosubmitController from "./autosubmit_controller"
application.register("autosubmit", AutosubmitController)

import BarcodeScannerController from "./barcode_scanner_controller"
application.register("barcode-scanner", BarcodeScannerController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import CheatGateController from "./cheat_gate_controller"
application.register("cheat-gate", CheatGateController)

import ComboboxController from "./combobox_controller"
application.register("combobox", ComboboxController)

import ConfirmController from "./confirm_controller"
application.register("confirm", ConfirmController)

import CopyDaysController from "./copy_days_controller"
application.register("copy-days", CopyDaysController)

import DatePickerController from "./date_picker_controller"
application.register("date-picker", DatePickerController)

import DayExpandController from "./day_expand_controller"
application.register("day-expand", DayExpandController)

import DayHeightController from "./day_height_controller"
application.register("day-height", DayHeightController)

import DayPickerController from "./day_picker_controller"
application.register("day-picker", DayPickerController)

import DismissController from "./dismiss_controller"
application.register("dismiss", DismissController)

import EnergyController from "./energy_controller"
application.register("energy", EnergyController)

import EntryController from "./entry_controller"
application.register("entry", EntryController)

import FeedbackController from "./feedback_controller"
application.register("feedback", FeedbackController)

import FilterSheetController from "./filter_sheet_controller"
application.register("filter-sheet", FilterSheetController)

import FoodCaloriesController from "./food_calories_controller"
application.register("food-calories", FoodCaloriesController)

import FoodTagsController from "./food_tags_controller"
application.register("food-tags", FoodTagsController)

import FormStepsController from "./form_steps_controller"
application.register("form-steps", FormStepsController)


import IngredientMacrosController from "./ingredient_macros_controller"
application.register("ingredient-macros", IngredientMacrosController)

import IngredientsController from "./ingredients_controller"
application.register("ingredients", IngredientsController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import LiveNutritionController from "./live_nutrition_controller"
application.register("live-nutrition", LiveNutritionController)

import MacroSplitController from "./macro_split_controller"
application.register("macro-split", MacroSplitController)


import MealDragController from "./meal_drag_controller"
application.register("meal-drag", MealDragController)

import MeasureToggleController from "./measure_toggle_controller"
application.register("measure-toggle", MeasureToggleController)

import MenuController from "./menu_controller"
application.register("menu", MenuController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NavDrawerController from "./nav_drawer_controller"
application.register("nav-drawer", NavDrawerController)

import NewFoodController from "./new_food_controller"
application.register("new-food", NewFoodController)

import OpenModalController from "./open_modal_controller"
application.register("open-modal", OpenModalController)

import OrphanCheckController from "./orphan_check_controller"
application.register("orphan-check", OrphanCheckController)

import PanelsController from "./panels_controller"
application.register("panels", PanelsController)

import PhotoUploadController from "./photo_upload_controller"
application.register("photo-upload", PhotoUploadController)

import PollController from "./poll_controller"
application.register("poll", PollController)

import RatePickerController from "./rate_picker_controller"
application.register("rate-picker", RatePickerController)

import RatingController from "./rating_controller"
application.register("rating", RatingController)

import ReviewKeysController from "./review_keys_controller"
application.register("review-keys", ReviewKeysController)

import ScalerController from "./scaler_controller"
application.register("scaler", ScalerController)

import SelectSearchController from "./select_search_controller"
application.register("select-search", SelectSearchController)

import ServingMacrosController from "./serving_macros_controller"
application.register("serving-macros", ServingMacrosController)

import ServingsController from "./servings_controller"
application.register("servings", ServingsController)

import ShareController from "./share_controller"
application.register("share", ShareController)

import SimilarFoodsController from "./similar_foods_controller"
application.register("similar-foods", SimilarFoodsController)

import SlotLabelController from "./slot_label_controller"
application.register("slot-label", SlotLabelController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import StepperController from "./stepper_controller"
application.register("stepper", StepperController)

import StyleguideFinderController from "./styleguide_finder_controller"
application.register("styleguide-finder", StyleguideFinderController)

import SubmitController from "./submit_controller"
application.register("submit", SubmitController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TimeZoneController from "./time_zone_controller"
application.register("time-zone", TimeZoneController)

import UnitGateController from "./unit_gate_controller"
application.register("unit-gate", UnitGateController)

import UnitPickerController from "./unit_picker_controller"
application.register("unit-picker", UnitPickerController)

import UnitRatiosController from "./unit_ratios_controller"
application.register("unit-ratios", UnitRatiosController)

import UnitsController from "./units_controller"
application.register("units", UnitsController)
